export default __webpack_public_path__ + "static/media/scene.ed66a989.svg";